package com.patronat.top.features.venues.data.repository

import com.patronat.top.core.domain.models.DomainResult
import com.patronat.top.core.network.asDomainResult
import com.patronat.top.dto.CreateVenueRequest
import com.patronat.top.dto.PatchVenueRequest
import com.patronat.top.dto.UpdateVenueRequest
import com.patronat.top.dto.VenueAssigneesResponse
import com.patronat.top.dto.VenueAiImportRequest
import com.patronat.top.dto.VenueAiImportResponse
import com.patronat.top.dto.VenueDraftResponse
import com.patronat.top.dto.VenueFilterRequest
import com.patronat.top.dto.VenueListResponse
import com.patronat.top.dto.VenueResponse
import com.patronat.top.dto.venues.VenueStatus
import com.patronat.top.features.venues.data.network.VenuesRemoteDataSource
import com.patronat.top.features.venues.domain.repository.VenuesRepository

class VenuesRepositoryImpl(
    private val remoteDataSource: VenuesRemoteDataSource
) : VenuesRepository {

    override suspend fun createVenue(request: CreateVenueRequest): DomainResult<VenueResponse> {
        return remoteDataSource.createVenue(request).asDomainResult { it }
    }

    override suspend fun importVenueWithAi(request: VenueAiImportRequest): DomainResult<VenueAiImportResponse> {
        return remoteDataSource.importVenueWithAi(request).asDomainResult { it }
    }

    override suspend fun getVenueById(venueId: String): DomainResult<VenueResponse> {
        return remoteDataSource.getVenueById(venueId).asDomainResult { it }
    }

    override suspend fun getVenueDraft(venueId: String): DomainResult<VenueDraftResponse> {
        return remoteDataSource.getVenueDraft(venueId).asDomainResult { it }
    }

    override suspend fun getSubmittedVenueDraft(venueId: String): DomainResult<VenueDraftResponse> {
        return remoteDataSource.getSubmittedVenueDraft(venueId).asDomainResult { it }
    }

    override suspend fun patchVenueDraft(venueId: String, request: PatchVenueRequest): DomainResult<VenueDraftResponse> {
        return remoteDataSource.patchVenueDraft(venueId, request).asDomainResult { it }
    }

    override suspend fun reviewVenueDraft(venueId: String, approved: Boolean): DomainResult<VenueDraftResponse> {
        return remoteDataSource.reviewVenueDraft(venueId, approved).asDomainResult { it }
    }

    override suspend fun updateVenue(venueId: String, request: UpdateVenueRequest): DomainResult<VenueResponse> {
        return remoteDataSource.updateVenue(venueId, request).asDomainResult { it }
    }

    override suspend fun getFilteredVenues(request: VenueFilterRequest): DomainResult<VenueListResponse> {
        return remoteDataSource.filterVenues(request).asDomainResult { it }
    }

    override suspend fun getVenueAssignees(): DomainResult<VenueAssigneesResponse> {
        return remoteDataSource.getVenueAssignees().asDomainResult { it }
    }

    override suspend fun reassignVenueModerator(venueId: String, moderatorId: String): DomainResult<VenueResponse> {
        return remoteDataSource.reassignVenueModerator(venueId, moderatorId).asDomainResult { it }
    }

    override suspend fun updateVenueStatus(venueId: String, status: VenueStatus): DomainResult<VenueResponse> {
        return remoteDataSource.updateVenueStatus(venueId, status).asDomainResult { it }
    }
}
